// extracted by mini-css-extract-plugin
export default {"submit_btn":"thirdPartyQuestionnaireStyles_submit_btn__QgfXw"};